















































import { SfImage, SfButton } from '~/components/StorefrontUi';
import {
  defineComponent,
  onMounted,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { useUser } from '~/modules/customer/composables/useUser';
import { onSocialSubmit } from '~/helpers/auth';
import { useUiNotification } from '~/composables';

export default defineComponent({
  name: 'MergingAccounts',
  components: {
    SfButton,
    SfImage,
  },
  setup() {
    const {
      loadSocialLoginButtonConfig,
      socialButtonConfig,
      loadSocialLoginAccountData,
      socialAccountData,
      linkSocialAccount,
      unlinkSocialAccount,
      loading,
    } = useUser();
    const { send: sendNotification } = useUiNotification();
    const router = useRouter();
    const { i18n, localePath } = useContext();

    onMounted(async () => {
      if (!socialButtonConfig.value || socialButtonConfig.value.length === 0) {
        await loadSocialLoginButtonConfig();
      }
      if (!socialAccountData.value || socialAccountData.value.length === 0) {
        await loadSocialLoginAccountData();
      }
    });

    const checkIsConnected = (type: String) => {
      if (socialAccountData?.value) {
        return socialAccountData.value?.find(
          (account) => account.type === type,
        );
      }
      return false;
    };

    const handleLinkUnlinkSocialAccount = async (type: String) => {
      if (checkIsConnected(type)) {
        const results = await unlinkSocialAccount({ type });
        if (results) {
          if (results.isSuccess) {
            await loadSocialLoginAccountData();
            router.push(localePath('/customer/my-profile'));
          }
          sendNotification({
            id: Symbol('unlink_social_account'),
            message: i18n.t(`${results.message}`) as string,
            type: results.isSuccess ? 'success' : 'danger',
            icon: 'cross',
            persist: false,
            title: 'Rozłączanie konta społecznościowego',
          });
        } else {
          sendNotification({
            id: Symbol('unlink_social_account'),
            message: i18n.t(
              'An error occurred while disconnecting the social account',
            ) as string,
            type: 'danger',
            icon: 'cross',
            persist: false,
            title: 'Rozłączanie konta społecznościowego',
          });
        }
      } else {
        const results = await linkSocialAccount({ type });
        if (results) {
          if (results.isSuccess) {
            await loadSocialLoginAccountData();
          }
          sendNotification({
            id: Symbol('link_social_account'),
            message: results.message,
            type: results.isSuccess ? 'success' : 'danger',
            icon: 'cross',
            persist: false,
            title: 'Łączenie konta społecznościowego',
          });
        } else {
          sendNotification({
            id: Symbol('link_social_account'),
            message: i18n.t(
              'An error occurred while connecting a social account',
            ) as string,
            type: 'danger',
            icon: 'cross',
            persist: false,
            title: 'Łączenie konta społecznościowego',
          });
        }
      }
    };

    return {
      socialButtonConfig,
      socialAccountData,
      handleLinkUnlinkSocialAccount,
      addBasePath,
      checkIsConnected,
      onSocialSubmit,
      loading,
      linkSocialAccount,
      unlinkSocialAccount,
    };
  },
});
